module.exports = __webpack_public_path__ + "img/section3.ac8f92cb.jpg";